module.exports = __webpack_public_path__ + "img/gold_frame.a7e8b696.png";